export const SHIFTS = "SHIFTS";
export const WORKERS = "WORKERS";
export const PRODUCTION_PLAN = "PRODUCTION_PLAN";
export const LABOR_REQUIREMENTS = "LABOR_REQUIREMENTS";
export const ROSTER = "ROSTER";
/** The shift roster: lines × shifts with their own crews, batches per day. */
export const SHIFT_ROSTER = "SHIFT_ROSTER";
export const ATTRIBUTES = "ATTRIBUTES";
export const HOURS = "HOURS";
/** Settings → Cleaning & changeover: activity times per machine (and product). */
export const LINE_ACTIVITIES = "LINE_ACTIVITIES";

/** The tabs that live under Settings, in the order of its sub-tabs. */
export const SETTINGS_TABS = [LABOR_REQUIREMENTS, LINE_ACTIVITIES, HOURS, ATTRIBUTES];
